// Holds a reference to the currently mounted Render3D instance, so
// commandsModule.js (outside the React tree) can reach it from a toolbar command.
const render3DRef = { current: null };

export default render3DRef;
